<template>
  <section
    class="pv-expanded-question"
    :class="[{ 'is-expanded': item.active }, { 'is-active': item.answer !== '' || item.active }]"
    @click.self.prevent="itemSelected(item)"
  >
    <label
      class="pv-expanded-question-label"
      :for="item.name"
      @click.self.prevent="itemSelected(item)"
      >{{ item.question }}
    </label>
    <textarea
      v-model="item.answer"
      class="pv-expanded-question-text-area"
      placeholder="Tell us more"
      :name="item.name"
    />
  </section>
</template>

<script>
/**
 * Almendra component for questions that need to hidde its text area; when the item is not active, it just shows the
 * label, but user clicks over question, the component emit the 'select-question' event.
 * @displayName expand-question
 */
export default {
  name: 'ExpandQuestion',
  props: {
    /**
     * Javascript object with the question parameters; is is needed the next fields.
     *
     * **question:** For the question label that will be shown
     *
     * **answer:** field when will be saved the textfield text.
     *
     * **name:** form name of textfield.
     *
     * **active:** Booleand flag to expand or collapse the textfield.
     */
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    itemSelected(item) {
      /**
       * Event emitting when the question is clicked
       * @property {object} item information of item selected
       */
      this.$emit('select-question', item);
    }
  }
};
</script>

<style lang="scss">
.pv-expanded-question {
  background-color: color(white);

  border: 1px solid color(white, darken, 2);
  border-radius: $br-default;

  cursor: pointer;
  display: flex;
  flex-flow: column;
  height: auto;

  line-height: font-size(s);
  margin-bottom: spacing(5);
  overflow-y: hidden;
  padding: spacing(3) 0;
  text-align: center;
  transition: transition(fast);
  width: 520px;

  &.is-expanded {
    height: 206px;

    .pv-expanded-question-label {
      margin-bottom: spacing(5);
    }

    .pv-expanded-question-text-area {
      border-width: 1px;
      height: 136px;
      margin: 0 spacing(7);
      padding: spacing(4) spacing(5) spacing(5) spacing(5);
    }
  }

  &.is-active {
    border: 1px solid color(green);
    border-radius: $br-default;
    box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.08);
  }

  .pv-expanded-question-label {
    color: color(black, lighten, 1);
    cursor: pointer;
    font-size: font-size(s);
    margin-bottom: spacing(none);
    padding: 0 spacing(7);
  }

  .pv-expanded-question-text-area {
    background-color: color(white, lighten, 1);
    border: 0 solid color(green);
    border-radius: $br-default;
    color: color(black, lighten, 1);
    font-size: font-size(s);
    height: 0;
    margin: 0;
    padding: 0;
    width: auto;
  }
}
</style>
